<ng-container *transloco="let t; read: 'ime.manufacturing.manufacturing-item'">
  <app-graph-button [title]="t('Graph')" (showGraph)="showGraph()" (showGraphBuilder)="showGraphBuilder()" [showGraphBuilderButton]="true"></app-graph-button>
</ng-container>
